import { gql } from '@apollo/client'

const INGREDIENT_SPECIAL_CASE_FRAGMENT = gql`
  fragment IngredientSpecialCaseFragment on IngredientSpecialCase {
    id
    name
    type
    description
    caseDefinition
    updatedBy {
      id
      name
    }
    updatedAt
  }
`

export default INGREDIENT_SPECIAL_CASE_FRAGMENT
